var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2a2 2 0 014 0h4a1 1 0 110 1.99H1a1 1 0 110-2h4zM2 13.5V6h2v7.5c0 .28.22.5.5.5H6V6h2v8h1.5a.5.5 0 00.5-.5V6h2v7.5A2.5 2.5 0 019.5 16h-5A2.5 2.5 0 012 13.5z"
  })));
};
export default SvgTrash;